import styled from 'styled-components';
import { Breakpoints, Grid, Type } from '../../../app/StyleGuide';

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Grid._3};
  align-items: center;

  @media screen and (min-width: ${Breakpoints.screen_sm}) {
    gap: ${Grid._2};
  }
`;

export const Title = styled.h3`
  margin: 0;
  font-size: ${Type.Scale._4};
  font-weight: ${Type.Weight.semibold};
  color: ${Type.Color.dark};

  @media screen and (min-width: ${Breakpoints.screen_sm}) {
    font-size: ${Type.Scale._5};
  }
`;

export const Subtitle = styled.p`
  margin: 0;
  font-size: ${Type.Scale._1};
  color: ${Type.Color.medium};

  @media screen and (min-width: ${Breakpoints.screen_sm}) {
    font-size: ${Type.Scale._2};
    max-width: 520px;
  }
`;

export const ButtonRow = styled.div`
  button {
    width: 100%;
  }

  @media screen and (min-width: ${Breakpoints.screen_sm}) {
    button {
      width: auto;
      min-width: 240px;
    }
  }
`;
